import React from 'react';
import clsx from 'clsx';
import { handleKeyEvent, handleOnClickEvent, RULESET_ID_SESSION_KEY } from 'Utils';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '@brighterion/br-ui';

import styles from './RuleSetSwitcher.css';

type RuleSetSwitcherProps = {
    ruleSets: RuleSets;
    handleRuleSetSwitch: (ruleSet: RuleSet) => void;
};

export const RuleSetSwitcher = ({ ruleSets, handleRuleSetSwitch }: RuleSetSwitcherProps) => {
    const { t } = useTranslation();
    const current = sessionStorage.getItem(RULESET_ID_SESSION_KEY);
    if (!current) {
        return <span className={styles.label}>{t('Default Ruleset')}</span>;
    }
    if (ruleSets.length === 1) {
        return <span className={styles.label}>{ruleSets[0].displayName}</span>;
    }
    const selectedRuleSet = ruleSets.filter((ruleSet) => ruleSet.id === Number(current));
    return (
        <Dropdown
            id='rule-set-switcher'
            menuAlignment='right'
            containerClassName={styles.menuDropdownContainer}
            menuDropdownClassName={styles.menuDropdown}
        >
            <>{selectedRuleSet[0].displayName}</>
            <>
                {ruleSets?.map((ruleSet: RuleSet) => {
                    const { id, displayName } = ruleSet;
                    return (
                        <div
                            key={id}
                            tabIndex={0}
                            role='button'
                            className={clsx([
                                styles.item,
                                selectedRuleSet[0].displayName === displayName && styles.active
                            ])}
                            onClick={handleOnClickEvent(() => handleRuleSetSwitch(ruleSet))}
                            onKeyUp={handleKeyEvent(() => handleRuleSetSwitch(ruleSet))}
                        >
                            {displayName ?? 'No Display Name'}
                        </div>
                    );
                })}
            </>
        </Dropdown>
    );
};
